import { render, staticRenderFns } from "./Orderby2.vue?vue&type=template&id=98da4aa8&scoped=true&"
import script from "./Orderby2.vue?vue&type=script&lang=js&"
export * from "./Orderby2.vue?vue&type=script&lang=js&"
import style0 from "./Orderby2.vue?vue&type=style&index=0&id=98da4aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98da4aa8",
  null
  
)

export default component.exports